import script from "./ProteinSystem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProteinSystem.vue?vue&type=script&setup=true&lang=js"

import "./ProteinSystem.vue?vue&type=style&index=0&id=76028305&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76028305"]])

export default __exports__